
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/stream-balcony-solar-system/specs",
      function () {
        return require("private-next-pages/stream-balcony-solar-system/specs/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/stream-balcony-solar-system/specs"])
      });
    }
  